import { render, staticRenderFns } from "./copyDrawer.vue?vue&type=template&id=6b843eb5"
import script from "./copyDrawer.vue?vue&type=script&lang=js"
export * from "./copyDrawer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports